import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _requestCount = signal(0);
  private _visible = signal(false);
  private _delayTimer: ReturnType<typeof setTimeout> | null = null;

  readonly isLoading = computed(() => this._visible());
  readonly hasPendingRequests = computed(() => this._requestCount() > 0);

  /** Con delay de 3 segundos — para requests que pueden ser rápidos */
  show(): void {
    this._requestCount.update((count) => count + 1);

    if (!this._delayTimer) {
      this._delayTimer = setTimeout(() => {
        if (this._requestCount() > 0) {
          this._visible.set(true);
        }
      }, 3000);
    }
  }

  /** Sin delay — para pantallas específicas que siempre muestran loader */
  showImmediate(): void {
    this._requestCount.update((count) => count + 1);
    this._visible.set(true);
  }

  hide(): void {
    this._requestCount.update((count) => Math.max(0, count - 1));

    if (this._requestCount() === 0) {
      this._visible.set(false);
      if (this._delayTimer) {
        clearTimeout(this._delayTimer);
        this._delayTimer = null;
      }
    }
  }

  /**
   * Reinicia el loader global ante flujos de recuperación (p. ej. timeout de inactividad)
   * cuando pueden quedar requests huérfanos en estados de error.
   */
  forceHideAll(): void {
    this._requestCount.set(0);
    this._visible.set(false);

    if (this._delayTimer) {
      clearTimeout(this._delayTimer);
      this._delayTimer = null;
    }
  }
}